import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { UFpercentual } from 'pages/Contracts/utils/disableUfFields'
import { FormComplementaryKeys } from './types'

interface Schema {
    id: FormComplementaryKeys
}

export const FormComplementaryValue = (
    contractRef?: string
): {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] => {
    return [
        {
            select: {
                id: 'identificadorTaxaMora',
                label: 'Possui Taxa de mora?',
                optionsType: 'booleanType',
                defaultValue: 'NAO'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaMora',
                label: 'Taxa de mora',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 12,
                isTooltip:
                    "Preencha apenas se o indicador 'TAXA DE MORA' for marcada como 'SIM'. O valor está em percentual (%) e com três casas decimais, por exemplo: 1,000%."
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },

        {
            select: {
                id: 'identificadorTaxaMulta',
                label: 'Possui Taxa de multa?',
                optionsType: 'booleanType',
                defaultValue: 'NAO'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaMulta',
                label: 'Taxa de multa',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 8,
                isTooltip:
                    "Preencha apenas se o indicador 'TAXA DE MULTA' for marcada como 'SIM'. O valor está em percentual (%) e com três casas decimais, por exemplo: 1,000%."
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorIOF',
                label: 'Valor de IOF',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaJurosMes',
                label: 'Taxa de juros mês',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 8
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaJurosAno',
                label: 'Taxa de juros ano',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 8
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaContrato',
                label: 'Valor Taxa do Contrato',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15,
                required: contractRef === 'PR'

            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'indices',
                label: 'Índices',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12 }
            }
        },
        {
            select: {
                id: 'identificadorComissao',
                label: 'Comissão?',
                optionsType: 'booleanType',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorComissao',
                label: 'Valor de comissão',
                maskReplace: UFpercentual?.includes(contractRef as string)
                    ? 'percentual'
                    : 'moeda',
                inputMode: 'numeric',
                maxLength: UFpercentual?.includes(contractRef as string)
                    ? 8
                    : 15,
                isTooltip: UFpercentual?.includes(contractRef as string)
                    ? "Preencha apenas se o indicador 'COMISSÃO' for marcada como 'SIM'. O valor está em percentual (%) e com três casas decimais, por exemplo: 1,000%."
                    : ''
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'indicacaoPenalidade',
                label: 'Existe penalidade?',
                optionsType: 'booleanType',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'penalidade',
                label: 'Penalidade',
                isTooltip:
                    "Preencha apenas se o indicador 'EXISTE PENALIDADE' for marcada como 'SIM'."
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'principalRecebedorPagamento',
                label: 'Principal recebedor do pagamento:'
            },
            layout: {
                type: 'col',
                layout: { base: 12 }
            }
        },
        {
            select: {
                id: 'tipoDocumentoRecebedor',
                label: 'Doc. recebedor',
                optionsType: 'doc'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'documentoPrincipalRecebedorPagamento',
                label: 'Nº do documento',
                maskReplace: 'registro'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'tipoDocumentoVendedor',
                label: 'Doc. vendedor',
                optionsType: 'doc'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'documentoVendedor',
                label: 'Nº do documento',
                maskReplace: 'registro'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'comentarios',
                label: 'Comentários',
                placeholder: 'Digite aqui'
            },
            layout: {
                type: 'col',
                layout: { base: 12 }
            }
        },
        {
            input: {
                id: 'correcaoMonetaria',
                label: 'Correção Monetária',
                placeholder: 'Digite aqui',
                inputMode: 'numeric',
                maxLength: 12,
                onInput: (e: any) =>
                    (e.target.value = e.target.value.replace(/[^\d]/g, ''))
            },
            layout: {
                type: 'col',
                layout: { base: 6 }
            }
        },
        {
            input: {
                id: 'fundoReserva',
                label: 'Fundo de Reserva',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        ...(contractRef === 'RS'
            ? [
                {
                    input: {
                        id: 'numeroCertidaoNegativaDebitos',
                        label: 'Nº Certidão Negativa de Débitos',
                        maxLength: 60
                    },
                    layout: {
                        type: 'col',
                        layout: { base: 12, md: 6 }
                    }
                } as const
            ]
            : []),
    ]
}
